var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { Role } from '../../roles/index.js';
import { OfficeLocationResponseDto } from './office-location.response.dto.js';
export class OfficeResponseDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    isActive;
    mainAdminId;
    hasAtLeastOneVideoCall;
    isPinoTestOffice;
    officeLocations;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeResponseDto.prototype, "id", void 0);
__decorate([
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Date)
], OfficeResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Date)
], OfficeResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeResponseDto.prototype, "deletedAt", void 0);
__decorate([
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Boolean)
], OfficeResponseDto.prototype, "isActive", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeResponseDto.prototype, "mainAdminId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], OfficeResponseDto.prototype, "hasAtLeastOneVideoCall", void 0);
__decorate([
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Boolean)
], OfficeResponseDto.prototype, "isPinoTestOffice", void 0);
__decorate([
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST, Role.SUPERADMIN] }),
    Type(() => OfficeLocationResponseDto),
    __metadata("design:type", Array)
], OfficeResponseDto.prototype, "officeLocations", void 0);
//# sourceMappingURL=office.response.dto.js.map